module.exports = __webpack_public_path__ + "static/media/cold_2.7114d94c.png";